export default "__VITE_ASSET__ud0awy$$__"